import { useQuery } from '@tanstack/react-query';
import userService from '../api/userService';

export const useCurrentVendor = () => {
    return useQuery({
        queryKey: ['currentVendor'],
        queryFn: () => userService.currentVendor(),
        staleTime: 5 * 60 * 1000, // cache 5 mins
        retry: false
    });
};

// const queryClient = useQueryClient();
// const mutation = useMutation(orderService.updateOrderStatus, {
//     onSuccess: () => {
//         queryClient.invalidateQueries('allOrders');
//         queryClient.invalidateQueries('recentOrders');
//     }
// });

export const useMe = () => {
    return useQuery({
        queryKey: ['me'],
        queryFn: () => userService.me(),
        staleTime: 5 * 60 * 1000
    });
};
